import * as moment from "moment";

export default class InstructorsPlace {
    Id: number = 0;
    Name: string = '';
    TimeFrom?: string = '';
    TimeTo?: string = '';
}